import { SITE_URL } from "@/lib/seo";
import { BRAND, ASSETS } from "@/lib/brand";

export const ORGANIZATION_LD = {
  "@type": "Organization",
  "@id": `${SITE_URL}/#organization`,
  name: "Rudrima",
  url: SITE_URL,
  logo: ASSETS.logo,
  email: BRAND.email,
  telephone: `+${BRAND.whatsapp}`,
  contactPoint: [{
    "@type": "ContactPoint",
    contactType: "customer support",
    telephone: `+${BRAND.whatsapp}`,
    email: BRAND.email,
    availableLanguage: ["en", "hi"],
    areaServed: "IN",
  }],
};

export const WEBSITE_LD = {
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  url: SITE_URL,
  name: "Rudrima",
  publisher: { "@id": `${SITE_URL}/#organization` },
  inLanguage: "en-IN",
};

export const graph = (...nodes) => ({ "@context": "https://schema.org", "@graph": [ORGANIZATION_LD, WEBSITE_LD, ...nodes] });

export const webPageLd = ({ path, name, description, type = "WebPage" }) => ({
  "@type": type,
  "@id": `${SITE_URL}${path}#webpage`,
  url: `${SITE_URL}${path}`,
  name,
  description,
  isPartOf: { "@id": `${SITE_URL}/#website` },
  about: { "@id": `${SITE_URL}/#organization` },
  inLanguage: "en-IN",
});

export const productLd = ({ path, product, fallbackTitle, fallbackPrice, description, image }) => ({
  "@type": "Product",
  "@id": `${SITE_URL}${path}#product`,
  name: product?.title || fallbackTitle,
  description: product?.description || description,
  image: [product?.featuredImage?.url, ...(product?.images || []).map((i) => i.url), image].filter(Boolean).filter((v, i, a) => a.indexOf(v) === i),
  brand: { "@type": "Brand", name: "Rudrima" },
  url: `${SITE_URL}${path}`,
  offers: {
    "@type": "Offer",
    url: `${SITE_URL}${path}`,
    priceCurrency: product?.currency || "INR",
    price: product ? Number(product.price.amount) : fallbackPrice,
    availability: product
      ? (product.availableForSale ? "https://schema.org/InStock" : "https://schema.org/OutOfStock")
      : "https://schema.org/InStock",
    itemCondition: "https://schema.org/NewCondition",
    seller: { "@id": `${SITE_URL}/#organization` },
  },
});

export const faqLd = (faqs) => ({
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});
